import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Logo from '../../assets/images/logo-white-clear-h2o.svg'
import CalendarIcon from '../../assets/images/icon-white-calendar.svg'

const propTypes = {
  navItems: PropTypes.array.isRequired,
}

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showMobileNav: false,
    }
    this.handleNavClick = this.handleNavClick.bind(this)
    this.handleItemClick = this.handleItemClick.bind(this)
  }

  componentDidUpdate() {
    this.toggleBodyClass()
  }

  handleNavClick() {
    this.setState({ showMobileNav: !this.state.showMobileNav })
  }

  handleItemClick() {
    const body = document.querySelector('body')

    this.handleNavClick()
    body.classList.remove('locked')
  }

  toggleBodyClass() {
    const { showMobileNav } = this.state
    const body = document.querySelector('body')

    showMobileNav
      ? body.classList.add('locked')
      : body.classList.remove('locked')
  }

  renderNav(showMobileNav) {
    return (
      <ul
        className={`site-navigation__wrapper ${showMobileNav ? 'active' : ''}`}
        role="navigation"
      >
        {this.props.navItems.map(item => (
          <li className="nav-item" key={item.displayName}>
            <Link
              className="nav-item__url"
              exact
              to={item.url}
              onClick={this.handleItemClick}
              activeClassName="nav-item__url--active"
            >
              {item.displayName}
            </Link>
          </li>
        ))}
        <a
          className="button booking-button"
          href="https://book-clear-h2o.web.app/"
          target="_blank"
        >
          <img src={CalendarIcon} alt="" />
          Create Booking
        </a>
      </ul>
    )
  }

  render() {
    const { showMobileNav } = this.state
    return (
      <header className="site-header">
        <div className="site-header__row">
          <Link className="site-header__logo-wrapper" exact to="/">
            <img className="site-header__logo" src={Logo} alt="Clear H2O" />
          </Link>
          <nav className="site-navigation">
            <div
              className={showMobileNav ? ' hamburger active' : 'hamburger'}
              onClick={this.handleNavClick}
            >
              <span className="hamburger__line hamburger__line--top"></span>
              <span className="hamburger__line hamburger__line--bottom"></span>
            </div>
            {this.renderNav(showMobileNav)}
          </nav>
        </div>
      </header>
    )
  }
}

Header.propTypes = propTypes

export default Header



// WEBPACK FOOTER //
// ./src/components/sections/Header.js